import { useState } from "react";
var sections = {
    personal_information: "Personal Information",
    company_information: "Company Information",
    product_information: "Product Information",
    purchase_preferences: "Purchase Preferences",
};
var personal_information = sections.personal_information, company_information = sections.company_information, product_information = sections.product_information, purchase_preferences = sections.purchase_preferences;
export var useUserProfileFormFields = function () {
    var _a = useState(""), firstName = _a[0], setFirstName = _a[1];
    var _b = useState(""), lastName = _b[0], setLastName = _b[1];
    var _c = useState(""), email = _c[0], setEmail = _c[1];
    var _d = useState(""), phone = _d[0], setPhone = _d[1];
    var _e = useState(""), city = _e[0], setCity = _e[1];
    var _f = useState(""), country = _f[0], setCountry = _f[1];
    var _g = useState(""), state = _g[0], setState = _g[1];
    var _h = useState(""), companyAssociation = _h[0], setCompanyAssociation = _h[1];
    var _j = useState(""), companyTitle = _j[0], setCompanyTitle = _j[1];
    var _k = useState(""), companyName = _k[0], setCompanyName = _k[1];
    var _l = useState(""), companyIndustry = _l[0], setCompanyIndustry = _l[1];
    var _m = useState(""), companyWebsite = _m[0], setCompanyWebsite = _m[1];
    var _o = useState(""), companyRevenue = _o[0], setCompanyRevenue = _o[1];
    var _p = useState(""), currentlyPurchasing = _p[0], setCurrentlyPurchasing = _p[1];
    var _q = useState(""), purchasingRegions = _q[0], setPurchasingRegions = _q[1];
    var _r = useState(""), seaweedSource = _r[0], setSeaweedSource = _r[1];
    var _s = useState(""), prodDevPhase = _s[0], setProdDevPhase = _s[1];
    var _t = useState(""), prodDescription = _t[0], setProdDescription = _t[1];
    var _u = useState(""), speciesPreferences = _u[0], setSpeciesPreferences = _u[1];
    var _v = useState(""), stabilizationPreferences = _v[0], setStabilizationPreferences = _v[1];
    var _w = useState(""), formPreferences = _w[0], setFormPreferences = _w[1];
    var _x = useState(""), purchasingTimeline = _x[0], setPurchasingTimeline = _x[1];
    var _y = useState(""), purchaseVolume = _y[0], setPurchaseVolume = _y[1];
    var _z = useState(""), purchaseVolumeForm = _z[0], setPurchaseVolumeForm = _z[1];
    var _0 = useState(""), targetPrice = _0[0], setTargetPrice = _0[1];
    var fieldList = [
        {
            name: "first",
            label: "First Name",
            value: firstName,
            setter: setFirstName,
            payloadKey: "first_name",
            section: personal_information,
            container: "one-sixth-container",
        },
        {
            name: "last",
            label: "Last Name",
            value: lastName,
            setter: setLastName,
            payloadKey: "last_name",
            section: personal_information,
            container: "one-sixth-container",
        },
        {
            name: "email",
            label: "Email",
            value: email,
            setter: setEmail,
            payloadKey: "email",
            section: personal_information,
        },
        {
            name: "phone",
            label: "Phone Number",
            value: phone,
            setter: setPhone,
            payloadKey: "phone",
            section: personal_information,
        },
        {
            name: "city",
            label: "City",
            value: city,
            setter: setCity,
            payloadKey: "city",
            section: personal_information,
            container: "one-sixth-container",
        },
        {
            name: "state",
            label: "State",
            value: state,
            setter: setState,
            payloadKey: "state",
            section: personal_information,
            container: "one-sixth-container",
        },
        {
            name: "country",
            label: "Country",
            value: country,
            setter: setCountry,
            payloadKey: "country",
            section: personal_information,
            container: "one-sixth-container",
        },
        {
            name: "companyAssociation",
            label: "Individual or Company?",
            value: companyAssociation,
            setter: setCompanyAssociation,
            payloadKey: "company_association",
            section: personal_information,
        },
        {
            name: "companyTitle",
            label: "Job Title",
            value: companyTitle,
            setter: setCompanyTitle,
            payloadKey: "company_title",
            section: company_information,
        },
        {
            name: "companyName",
            label: "Company name",
            value: companyName,
            setter: setCompanyName,
            payloadKey: "company_name",
            section: company_information,
        },
        {
            name: "companyIndustry",
            label: "Industry",
            value: companyIndustry,
            setter: setCompanyIndustry,
            payloadKey: "company_industry",
            section: company_information,
        },
        {
            name: "companyWebsite",
            label: "Website",
            value: companyWebsite,
            setter: setCompanyWebsite,
            payloadKey: "company_website",
            section: company_information,
        },
        {
            name: "companyRevenue",
            label: "Annual revenue",
            value: companyRevenue,
            setter: setCompanyRevenue,
            payloadKey: "company_revenue",
            section: company_information,
        },
        {
            name: "currentlyPurchasing",
            label: "Are you currently purchasing seaweed?",
            value: currentlyPurchasing,
            setter: setCurrentlyPurchasing,
            payloadKey: "currently_purchasing",
            section: product_information,
        },
        {
            name: "purchasingRegions",
            label: "From which region(s) do you currently source seaweed?",
            value: purchasingRegions,
            setter: setPurchasingRegions,
            payloadKey: "purchasing_regions",
            section: product_information,
        },
        {
            name: "seaweedSource",
            label: "How is the seaweed you source grown?",
            value: seaweedSource,
            setter: setSeaweedSource,
            payloadKey: "seaweed_source",
            section: product_information,
        },
        {
            name: "prodDevPhase",
            label: "Where are you in product development?",
            value: prodDevPhase,
            setter: setProdDevPhase,
            payloadKey: "prod_dev_phase",
            section: product_information,
        },
        {
            name: "prodDescription",
            label: "Product description",
            value: prodDescription,
            setter: setProdDescription,
            payloadKey: "prod_description",
            section: product_information,
        },
        {
            name: "speciesPreferences",
            label: "Species preferences",
            value: speciesPreferences,
            setter: setSpeciesPreferences,
            payloadKey: "species_preferences",
            section: purchase_preferences,
        },
        {
            name: "stabilizationPreferences",
            label: "Stabilization preferences",
            value: stabilizationPreferences,
            setter: setStabilizationPreferences,
            payloadKey: "stabilization_preferences",
            section: purchase_preferences,
        },
        {
            name: "formPreferences",
            label: "Form preferences",
            value: formPreferences,
            setter: setFormPreferences,
            payloadKey: "form_preferences",
            section: purchase_preferences,
        },
        {
            name: "purchasingTimeline",
            label: "Purchasing timeline",
            value: purchasingTimeline,
            setter: setPurchasingTimeline,
            payloadKey: "purchasing_timeline",
            section: purchase_preferences,
        },
        {
            name: "purchaseVolume",
            label: "Purchase volume",
            value: purchaseVolume,
            setter: setPurchaseVolume,
            payloadKey: "purchase_volume",
            section: purchase_preferences,
        },
        {
            name: "purchaseVolumeForm",
            label: "Purchase volume form",
            value: purchaseVolumeForm,
            setter: setPurchaseVolumeForm,
            payloadKey: "purchase_volume_form",
            section: purchase_preferences,
        },
        {
            name: "targetPrice",
            label: "Target price",
            value: targetPrice,
            setter: setTargetPrice,
            payloadKey: "target_price",
            section: purchase_preferences,
        },
    ];
    return {
        fieldList: fieldList,
        values: {
            first_name: firstName,
            last_name: lastName,
            phone: phone,
            country: country,
            state: state,
            city: city,
            company_association: companyAssociation,
            company_title: companyTitle,
            company_name: companyName,
            company_industry: companyIndustry,
            company_website: companyWebsite,
            company_revenue: companyRevenue,
            currently_purchasing: currentlyPurchasing,
            purchasing_regions: purchasingRegions,
            seaweed_source: seaweedSource,
            prod_dev_phase: prodDevPhase,
            prod_description: prodDescription,
            species_preferences: speciesPreferences,
            stabilization_preferences: stabilizationPreferences,
            form_preferences: formPreferences,
            purchasing_timeline: purchasingTimeline,
            purchase_volume: purchaseVolume,
            purchase_volume_form: purchaseVolumeForm,
            target_price: targetPrice,
        },
    };
};
//# sourceMappingURL=useUserProfileFormFields.js.map